import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './login.scss';
import Logo from '../assets/images/logo-admin.svg';
import Form from 'react-bootstrap/Form';
import { useUserContext } from '../contexts/users-context';
import { useNavigate } from 'react-router';
import Spinner from '../components/loading/loading';
import { URL } from '../hooks/fetchdata';

import { GoogleLogin, googleLogout } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';  // Correct import

// Images
import googleIcon from '../assets/images/login/googleIcon.png';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [idToken,setIdToken] = useState('')
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [importantPhone, setImportantPhone] = useState(false)
  const { setToken } = useUserContext();
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  // post uchun formatlash
  const reformatUzPhone = (input) => {
    // Faqat raqamlarni qoldiramiz
    let digits = input.replace(/\D/g, "");

    // Agar 998 bilan boshlanmasa majburlab qo‘yamiz
    if (!digits.startsWith("998")) {
      digits = "998" + digits.replace(/^998/, "");
    }

    // Maksimal 12 ta raqam (998 + 9 ta raqam)
    digits = digits.slice(0, 12);

    return "+" + digits;
  };
  useEffect(() => {
    setPhone('+998')
  }, [])
  
  // telefonni formatlash
  const formatUzPhone = (input) => {
    const digits = input.replace(/\D/g, "");
    if (!digits.startsWith("998")) return "+998";

    let out = "+998 ";
    if (digits.length > 3) out += "(" + digits.slice(3, 5);
    if (digits.length > 5) out += ")-" + digits.slice(5, 8);
    if (digits.length > 8) out += "-" + digits.slice(8, 10);
    if (digits.length > 10) out += "-" + digits.slice(10, 12);

    return out.trim();
  };

  const handlePhoneChange = (e) => {
    const formatted = formatUzPhone(e.target.value);
    setPhone(formatted);
  };

  const handlePhoneKeyDown = (e) => {
    if (e.key === 'Backspace' && phone.length <= 5) {
      e.preventDefault();
    }
  };


  const onSuccess = async (response) => {
    try {
      const id_token = response.credential;
      console.log('Google ID token:', id_token);
      setIdToken(id_token)
      const res = await fetch(`${URL}/api/auth/google/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id_token }),
      });

      const data = await res.json();
      console.log('Backend response:', data);

      if (res.ok) {
        // Agar backend OK bo'lsa, token va user saqlash
        const accessToken = data.tokens.access;
        const refreshToken = data.tokens.refresh;

        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('refreshToken', refreshToken);
        setToken(accessToken);
        setUser(data.user);
        navigate('/');
      } else {
        if (data.error === "Birinchi marta Google bilan ro'yxatdan o'tishda phone majburiy!") {
          setError(data.error);
          setImportantPhone(true)
        } else {
          setError(data.error || 'Google login failed.');
        }
      }
    } catch (err) {
      console.error('Google login error:', err);
      setError('Google login failed. Try again.');
    }
  };


// phone register
const submitPhoneHandler = async (e) => {
  e.preventDefault();
  if(reformatUzPhone(phone).length<=12){
    setError('Malumotlarni to\'liq kiriting')
  }
  else{
    try {
      const res = await fetch(`${URL}/api/auth/google/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id_token: idToken,
          phone: reformatUzPhone(phone),
        }),
      });
  
      const data = await res.json();
      if (res.ok) {
        localStorage.setItem('accessToken', data.tokens.access);
        localStorage.setItem('refreshToken', data.tokens.refresh);
        setToken(data.tokens.access);
        setUser(data.user);
        navigate('/');
      } else {
        setError(data.error || 'Phone submit failed');
      }
    } catch (err) {
      setError(err.data);
      console.log(err.data);
      
    }
  }
};

  const onFailure = (error) => {
    console.log('Login Failed:', error);
  };

  const handleLogout = () => {
    googleLogout();
    setUser(null); // Clear the user information
    localStorage.removeItem('accessToken');
    console.log('Logout Success');
  };

  async function SignInHandler(e) {
    e.preventDefault();
    if(reformatUzPhone(phone).length<=12){
    setError('Malumotlarni to\'liq kiriting')
    return;
  }
  else{
    setLoading(true);
    console.log(phone.trim());
    try {
      const response = await fetch(`${URL}/api/auth/login/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ phone: reformatUzPhone(phone), password: password }),
      });

      const data = await response.json();
      setLoading(false);

      console.log(data);

      if (response.status === 200) {
        localStorage.setItem('accessToken', data.tokens.access);
        setToken(data.tokens.refresh);
        console.log(data);

        if (data.user.user_type) {
          console.log('User is staff or superuser.');
          navigate('/dashboard/');
        } else {
          console.log('User is not staff.');
          navigate('/');
        }
      } else {
        setError(data.error || 'Login failed. Please check your credentials.');
      }
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      setError(error);
    }
  }
  }

  return (
    <div className='log'>
      {loading && <Spinner />}
      {importantPhone ?
        <Form onSubmit={submitPhoneHandler} className='signup-container login loginm w-md-30' style={{boxShadow:'2px 1px 20px'}}>
          <Form.Group className="mb-3 z-50">
            <Form.Label>Telefon raqamingizni kirting</Form.Label>
            <Form.Control
              type="tel"
              required
              value={phone}
              onChange={handlePhoneChange}
              onKeyDown={handlePhoneKeyDown}
              placeholder="+998 90 123 45 67"
            />
          </Form.Group>
          {error && <div className='alert alert-danger py-2 px-3 mt-2'>{error}</div>}
          <button className="primary-button" variant="primary" type="submit" style={{marginBottom:0}}>
            Kirish
          </button>
        </Form> :
        <div className="signup-container login loginm w-md-30">
          <Link to="/">
            <img
              style={{
                display: 'flex',
                justifyContent: 'center',
                margin: '0 auto',
              }}
              src={Logo}
              alt=""
            />
          </Link>
          <Form onSubmit={SignInHandler}>
            <Form.Group className="mb-3">
              <Form.Label>Telefon raqami</Form.Label>
              <Form.Control
                type="tel"
                required
                value={phone}
                onChange={handlePhoneChange}
                onKeyDown={handlePhoneKeyDown}
                placeholder="+998 90 123 45 67"
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Parol</Form.Label>
              <Form.Control
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                placeholder="parol"
                value={password}
                required
              />
            </Form.Group>
            {error && <div className="alert alert-danger py-2 px-3 mt-2">{error}</div>}
            <button className="primary-button" variant="primary" type="submit">
              Kirish
            </button>
            <div className="signupContainer top">
              Akkountingiz yo'qmi? <Link to="/signup">Ro'yxatdan o'tish</Link>
            </div>
            <div className="otherLoginForm loginForm">
              <span id="line"></span>
              <div class="divider">
                <span class="line"></span>
                <span class="or-text">yoki</span>
                <span class="line"></span>
              </div>
              <GoogleLogin
                className="google-auth"
                onSuccess={onSuccess}
                onFailure={onFailure}
              />
            </div>
          </Form>
        </div>
      }
    </div >
  );
};

export default Login;
